
import axios from "axios";
import { getAgencesByWilayaSuccess } from "./AgenceActions";
import { API_URL } from "../../config/runtimeConfig";

const axiosInstance = axios.create({
    baseURL: API_URL,
});


export const getAgencesByWilaya = async(dispatch)=>{
    try{
        const res = await axiosInstance.get(`/admin/agences`,{
            headers : {
                token : `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getAgencesByWilayaSuccess(res.data));
    }catch(err){
        if(err.response){
            console.log(err.response.data.message);
        }else{
            console.log("Unkown Error");
        }
    }
}